import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import IPlanEntete from "../../models/IPlanEntete";
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';
import useLookUpBase from '../../components/selectbox/LookupBase';
import { Column, Lookup } from 'devextreme-react/data-grid';
import { GroupItem, SimpleItem, Label } from 'devextreme-react/form';

interface IGestionPlansProps {
  isModeSelection?: boolean;
}

class PlanEntete extends IBaseModel implements IPlanEntete {
  idPlanEntete: Guid = Guid.empty;
  idFolio: Guid = Guid.empty;
  idPlanEnteteEnfant: Guid = Guid.empty;
  idActivite: Guid = Guid.empty;
  idPlanEntetePersAdd: Guid = Guid.empty;
  descriptionFrancaise: string = '';
  descriptionAnglaise: string = '';
  prixAdulte: number = 0;
  prixEnfant: number = 0;
  fraisServices: number = 0;
  dejeunerInclus: boolean = false;
  dinerInclus: boolean = false;
  souperInclus: boolean = false;
  escomptable: boolean = false;
  actif: boolean = false;
  forfaitIndividuel: boolean = false;
  forfaitJournalier: boolean = false;
  forfaitGlobal: boolean = false;
  tpsIncluse: boolean = false;
  tvqIncluse: boolean = false;
  txHebIncluse: boolean = false;
  tpsRemboursableNonResident: boolean = false;
  descriptionWeb: string = '';
  descriptionWebAnglais: string = '';
  inclureEnfantsDansNombrePersonnes: boolean = false;
  couleurPlanTexte: number = 0;
  couleurPlanBackground: number = 0;
  prixEnfantUtiliserPourcentageAdulte: boolean = false;
  prixEnfantPourcentageAdulte: number = 0;
  ordreAffichage: number = 0;
  nbPersonnesAvantPlanPersAdd: number = 0;
  nbAdultesAvantPlanAdd: number = 0;
  nbEnfantsAvantPlanAdd: number = 0;
  repartirJourneesSejourDecortiquer: boolean = false;
  taxableTps: boolean = false;
  taxableTvq: boolean = false;
}

export default function GestionPlansSimple({ isModeSelection }: IGestionPlansProps) {
  const { editorOptions: folioEditorOption } = useLookUpBase({ controllerName: "folio", cacheKey: "folio-plans-simple" });
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="PlanEntete" model={PlanEntete}
      additionalColumns={
        <>
          <Column key={"grid-col-description"} dataField={"descriptionFrancaise"} caption="Description" allowHiding={false} />
          <Column key={"grid-col-folio"} dataField={"idFolio"} caption="Folio" allowHiding={false}>
            <Lookup {...folioEditorOption} />
          </Column>
          <Column key={"grid-col-prix-adultes"} dataField={"prixAdulte"} caption="Prix adultes" allowHiding={false} />
          <Column key={"grid-col-prix-enfant"} dataField={"prixEnfant"} caption="Prix enfant" allowHiding={false} />
          <Column key={"grid-col-mode-calcul"} dataField={"modeCalcul"} caption="Mode de calcul" allowHiding={false} />
        </>
      }
      customFormItems={(selectedPlanDetailType) => (
        <SimpleItem key={"frm-descriptionFrancaise"} dataField={"descriptionFrancaise"}>
          <Label text={"Description française"} showColon={false} />
        </SimpleItem>
      )}
    />
  );
}